import React from 'react';
import PieSVG from './PieSVG';
import PropTypes from 'prop-types';
import { formatPercent } from '../../helpers/Text';
import './tooltip.scss';

class Doughnut extends React.PureComponent {
  render() {
    const {
      listData,
      colors,
      title,
      tooltipPaddingX,
      tooltipPaddingY,
      renderTooltip,
    } = this.props;

    listData.forEach(item => {
      let formatPercenValue = +formatPercent(item.item2);
      if (item.item2 > 0 && formatPercenValue < 1) {
        item.item3 = 1;
      } else {
        item.item3 = formatPercenValue;
      }
    });

    return (
      <div className="ownership">
        <div className="chart_wrap_ownership">
          <div className="title_tooltip">{title}</div>
          <PieSVG
            renderTooltip={renderTooltip}
            data={listData}
            colors={colors}
            width={120}
            height={120}
            innerRadius={35}
            outerRadius={60}
            tooltipPaddingX={tooltipPaddingX}
            tooltipPaddingY={tooltipPaddingY}
          />
        </div>
      </div>
    );
  }
}

Doughnut.propTypes = {
  listData: PropTypes.array,
  colors: PropTypes.array,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  renderTooltip: PropTypes.func,
};

Doughnut.defaultProps = {
  listData: [],
  colors: [],
  title: '',
  renderTooltip: null,
};

export default Doughnut;
